import { Link } from "react-router-dom";
import { Play, Eye } from "lucide-react";
import { mediaUrl } from "@/lib/api";

export const reelVideo = (r) => mediaUrl(r.video || r.video_url || r.media);
export const reelTitle = (r) => r.caption || r.title || r.text || "";

export const ReelThumb = ({ reel }) => (
  <Link to={`/reels?r=${reel.id}`} className="group relative block aspect-[9/16] overflow-hidden rounded-2xl bg-tm-dark" data-testid={`reel-thumb-${reel.id}`}>
    <video src={reelVideo(reel)} muted preload="metadata" className="h-full w-full object-cover" />
    <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
    <Play className="absolute left-1/2 top-1/2 h-10 w-10 -translate-x-1/2 -translate-y-1/2 text-white/90 transition-transform duration-200 group-hover:scale-110" />
    <div className="absolute inset-x-0 bottom-0 p-3 text-white">
      <p className="line-clamp-2 text-sm font-semibold">{reelTitle(reel)}</p>
      <p className="mt-1 flex items-center gap-1 text-xs text-white/70"><Eye className="h-3 w-3" />{reel.views_count ?? reel.views ?? 0}</p>
    </div>
  </Link>
);
